<template>
  <div id="sitter-rating" class="container">
    <div class="p-24">
      <div class="v-align mb-50px">
        <div
          class="animate-pulse bg-grey-divider-subdued w-80 h-80 mr-16 rounded-full sm-vertical-spacing inline-block align-middle"
        />
        <div class="animate-pulse bg-grey-divider-subdued w-[100px] h-[20px] ml- sm-vertical-spacing inline-block align-middle" />
      </div>
      <div class="animate-pulse bg-grey-divider-subdued w-[400px] h-[24px] sm-vertical-spacing" />
      <div class="animate-pulse bg-grey-divider-subdued w-[200px] h-[32px] sm-vertical-spacing" />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'RatingsLoadingSkeleton',
};
</script>
